import PropTypes from 'prop-types';
import React from 'react';
import { compose, withProps } from 'recompose';
import { reduxForm } from 'redux-form';
import Modal from './Modal';
import Input from './input';

const EmailPromptModal = ({ title, handleSubmit }) => (
  <Modal title={title}>
    <div className="u-ph u-pv">
      <form onSubmit={handleSubmit} className="layout u-mt">
        <div className="layout__item u-5/6">
          <Input
            className="c-input"
            name="email"
            type="email"
            placeholder="Email"
          />
        </div>
        <div className="layout__item u-1/6">
          <button
            type="submit"
            className="c-btn c-btn--medium u-height-40 u-block u-ph"
          >Import</button>
        </div>
      </form>
    </div>
  </Modal>
);

EmailPromptModal.propTypes = {
  title: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
};

EmailPromptModal.defaultProps = {
  title: '',
};

const enhance = compose(
  withProps(props => ({
    initialValues: {
      email: props.defaultEmail,
    },
  })),
  reduxForm({
    form: 'emailPromptForm',
  }),
);

export default enhance(EmailPromptModal);
